module.exports = __webpack_public_path__ + "img/bg5.6cf9000e.jpg";